<template>
  <div>
    <div
      style="display: flex;justify-content: space-between;align-items: center;padding: 10px 0;"
    >
      <div>
        <el-button
          v-show="isSortShow"
          type="primary"
          class="button"
          @click="saveSortData()"
          >保存排序</el-button
        >
        <el-button
          class="button"
          style="margin-right: 10px;"
          type="primary"
          @click="editSort()"
          >排序管理</el-button
        >
      </div>
      <el-button class="button" type="primary" @click="add">新增</el-button>
    </div>
    <el-table
      :data="fenData"
      style="width: 100%; margin-bottom: 20px"
      v-show="isSortShow"
      ref="multipleTable"
      row-key="id"
      border
    >
      <el-table-column prop="name" align="center" label="名称" width="150">
      </el-table-column>
      <el-table-column prop="id" align="center" label="ID" width="150">
      </el-table-column>
      <el-table-column label="移动" align="center" width="180">
        <template slot-scope="scope">
          <el-button type="text" @click="moveUp(scope.row, scope.$index, 2)"
            >上</el-button
          >
          <el-button type="text" @click="moveDown(scope.row, scope.$index, 2)"
            >下</el-button
          >
          <!-- <el-button
                type="text"
                @click="moveTop(scope.row, scope.$index, 2)"
                >置顶</el-button
              >
              <el-button
                type="text"
                @click="moveBottom(scope.row, scope.$index, 2)"
                >置底</el-button
              > -->
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.p_id == 0"
            type="text"
            icon="el-icon-edit"
            @click="handleSon(scope.row)"
            >添加子分类</el-button
          >
          <el-button
            v-if="scope.row.p_id == 0"
            type="text"
            icon="el-icon-edit"
            @click="handleEdit(scope.row, 1)"
            >编辑</el-button
          >
          <el-button
            v-else
            type="text"
            icon="el-icon-edit"
            @click="handleEdit(scope.row, 2)"
            >编辑</el-button
          >
          <el-button
            v-if="scope.row.p_id == 0"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row, 1)"
            >删除</el-button
          >
          <el-button
            v-else
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row, 2)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-table
      :data="fenData"
      style="width: 100%; margin-bottom: 20px"
      row-key="id"
      v-show="!isSortShow"
      :tree-props="{ children: 'sub_items' }"
      border
    >
      <el-table-column prop="name" align="center" label="名称" width="150">
      </el-table-column>
      <el-table-column prop="id" align="center" label="ID" width="150">
      </el-table-column>
      <el-table-column label="移动" align="center" width="180">
        <template slot-scope="scope">
          <el-button type="text" @click="moveUp(scope.row, scope.$index, 2)"
            >上</el-button
          >
          <el-button type="text" @click="moveDown(scope.row, scope.$index, 2)"
            >下</el-button
          >
          <!-- <el-button
                type="text"
                @click="moveTop(scope.row, scope.$index, 2)"
                >置顶</el-button
              >
              <el-button
                type="text"
                @click="moveBottom(scope.row, scope.$index, 2)"
                >置底</el-button
              > -->
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.p_id == 0"
            type="text"
            icon="el-icon-edit"
            @click="handleSon(scope.row)"
            >添加子分类</el-button
          >
          <el-button
            v-if="scope.row.p_id == 0"
            type="text"
            icon="el-icon-edit"
            @click="handleEdit(scope.row, 1)"
            >编辑</el-button
          >
          <el-button
            v-else
            type="text"
            icon="el-icon-edit"
            @click="handleEdit(scope.row, 2)"
            >编辑</el-button
          >
          <el-button
            v-if="scope.row.p_id == 0"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row, 1)"
            >删除</el-button
          >
          <el-button
            v-else
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row, 2)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑弹出框 -->
    <el-dialog
      :visible.sync="editVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="120px">
        <el-form-item label="分类名称：" prop="title">
          <el-input v-model="form.name"></el-input>
        </el-form-item>

        <el-form-item label="备注：" prop="remark">
          <el-input type="textarea" v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveEdit()">提 交</el-button>

        <el-button type="primary" @click="editVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 编辑弹出框 -->
    <el-dialog
      :visible.sync="editVisible1"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form :model="form1" label-width="120px">
        <el-form-item label="分类名称：" prop="title">
          <el-input v-model="form1.name"></el-input>
        </el-form-item>

        <el-form-item label="父级分类：" prop="father_class">
          <el-select v-model="form1.father_class" class="handle-select mr10">
            <el-option
              v-for="(child, index) in father_class"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注：" prop="remark">
          <el-input type="textarea" v-model="form1.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="submit()">提 交</el-button>

        <el-button type="primary" @click="editVisible1 = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from "../../../api/zkApiConfig";
import Sortable from "sortablejs";
export default {
  data() {
    return {
      editVisible: false,
      editVisible1: false,
      loading: false,
      father_class: [],
      fenData: [],
      form: {},
      form1: {},
      is_add: 0,
      father_add: true,
      dataArr: [],
      ids: [],
      isSortShow: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // 列表
    getData() {
      http.get("/admin/categories/yw_categories").then((res) => {
        if (res.data.status_code == 200) {
          this.fenData = res.data.data;
          this.father_class = res.data.data;
          this.dataArr = res.data.data;
          this.$nextTick(() => {
            this.initSortTable();
          });
        } else {
          this.$message.success(res.data.msg);
        }
      });
    },
    // 排序管理
    editSort() {
      this.isSortShow = !this.isSortShow;
    },
    // 保存排序
    saveSortData() {
      this.ids = [];
      for (let i = 0; i < this.dataArr.length; i++) {
        this.ids.push(this.dataArr[i].id);
      }
      let params = {
        ids: this.ids.toString(),
      };
      http.put("/admin/categories/sort/yw", params).then((res) => {
        if (res.data.status_code == 200) {
          this.$message.success("保存成功");
          this.isSortShow = false;
          this.getData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 拖拽
    initSortTable() {
      // 获取 el-table
      const tableTag = this.$refs["multipleTable"].$el;
      // 获取 tbody 节点
      const elTbody = tableTag.querySelectorAll(
        ".el-table__body-wrapper > table > tbody"
      )[0];
      // 拖拽排序
      this.sortable = Sortable.create(elTbody, {
        onEnd: (evt) => {
          const tempIndex = this.dataArr.splice(evt.oldIndex, 1)[0];
          this.dataArr.splice(evt.newIndex, 0, tempIndex);
          console.log(this.dataArr, "dataArr");
        },
      });
    },
    // 新增
    add() {
      this.father_add = true;
      this.form = {};
      this.editVisible = true;
    },
    // 父分类
    saveEdit() {
      if (this.father_add == true) {
        let params = {
          name: this.form.name,
          p_id: 0,
          remark: this.form.remark,
        };
        http.post("/admin/categories/yw_categories/add", params).then((res) => {
          if (res.data.status_code == 200) {
            this.getData();
            this.editVisible = false;
            this.$message.success("新增成功");
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else if (this.father_add == false) {
        let params = {
          name: this.form.name,
          p_id: 0,
          remark: this.form.remark,
        };
        http
          .put("/admin/categories/yw_categories/" + this.id, params)
          .then((res) => {
            if (res.data.status_code == 200) {
              this.getData();
              this.editVisible = false;
              this.$message.success("修改成功");
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }
    },
    // 子分类
    submit() {
      if (this.is_add == true) {
        let params = {
          name: this.form1.name,
          p_id: this.form1.father_class,
          remark: this.form1.remark,
        };
        http.post("/admin/categories/yw_categories/add", params).then((res) => {
          if (res.data.status_code == 200) {
            this.getData();
            this.editVisible1 = false;
            this.$message.success("新增子分类成功");
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else if (this.is_add == false) {
        let params = {
          name: this.form1.name,
          p_id: this.form1.father_class,
          remark: this.form1.remark,
        };
        http
          .put("/admin/categories/yw_categories/" + this.id, params)
          .then((res) => {
            if (res.data.status_code == 200) {
              this.getData();
              this.editVisible1 = false;
              this.$message.success("修改子分类成功");
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }
    },

    // 编辑
    handleEdit(row, type) {
      if (type == 1) {
        this.form = {
          name: row.name,
          remark: row.remark,
          father_class: row.id,
        };
        this.id = row.id;
        this.father_add = false;
        this.editVisible = true;
      } else if (type == 2) {
        this.form1 = {
          name: row.name,
          remark: row.remark,
          father_class: row.p_id,
        };
        this.is_add = false;
        this.editVisible1 = true;
      }
      console.log(row, "row");
    },
    // 添加子分类
    handleSon(row) {
      this.form1 = {};
      this.is_add = true;
      this.editVisible1 = true;
      this.form1.father_class = row.id;
    },
    // 删除
    handleDelete(row, type) {
      if (type == 1) {
        let that = this;
        // 二次确认删除
        //
        that
          .$confirm("确定要删除吗？", "提示", {
            type: "warning",
          })
          .then(() => {
            http
              .delete("/admin/categories/yw_categories/" + row.id)
              .then((res) => {
                if (res.data.status_code == 200) {
                  that.getData();
                  that.$message.success("删除成功");
                } else {
                  that.$message.error(res.data.msg);
                }
              });
          })
          .catch(() => {});
      } else if (type == 2) {
        let that = this;
        // 二次确认删除
        //
        that
          .$confirm("确定要删除吗？", "提示", {
            type: "warning",
          })
          .then(() => {
            http
              .delete("/admin/categories/yw_categories/" + row.id)
              .then((res) => {
                if (res.data.status_code == 200) {
                  that.getData();
                  that.$message.success("删除成功");
                } else {
                  that.$message.error(res.data.msg);
                }
              });
          })
          .catch(() => {});
      }
    },
    // 时间
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
  },
};
</script>

<style scoped>
.header-tab {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.button {
  height: 40px;
  float: right;
}
/deep/.el-tabs__header {
  width: 903px !important;
}
/deep/.el-tabs__item {
  width: 300px !important;
  text-align: center;
}
/deep/.is-active {
  border-bottom-color: #409eff !important;
}
/deep/.el-table__header {
  width: 100% !important;
}
/deep/.el-table__empty-block {
  width: 100% !important;
}
/deep/.el-table__body {
  width: 100% !important;
}
</style>
